import { mapZones } from 'nmr-processing';
import { getDetectionZones } from './getDetectionZones';
export function detectZones(datum, options) {
    const zones = getDetectionZones(datum, options);
    return mapZones(zones, datum);
}
